import React from "react";
import { Header } from "../../../../styleguide/atoms/index.js";
import { PopupWrapper, PopupRow, PopupResults } from "../../styles/Game.styles";
import { CharacterCard } from "../CharacterCard.js";
import { joinWithAnd } from "../../utils/gameUi";

export default function NightOverlay({
  lifeguardSavedNames,
  hasNightProtectedRaw,
  nightSaved,
  nightSavedAsset,
  nightSavedDescNodes,
  nightKillVictims,
  hasNightKillsRaw,
  roleAssets,
  renderRichText,
}) {
  const hasLGNames = (lifeguardSavedNames || []).length > 0;
  const hasSaved = !!nightSaved;

  // Raw truth from the game doc (independent of players loading)
  const hadAnyLG = !!hasNightProtectedRaw;
  const hadAnyKills = !!hasNightKillsRaw;

  // Only say "everyone survived" if the *raw* data says truly nothing happened
  if (!hadAnyLG && !hadAnyKills && !hasSaved) {
    return (
      <PopupWrapper>
        <PopupResults>
          <Header type="h3" align="center" padding="0">
            Everyone survived the night!
          </Header>
        </PopupResults>
      </PopupWrapper>
    );
  }

  const killedNames = (nightKillVictims || [])
    .map((v) => v?.name)
    .filter(Boolean);

  return (
    <PopupWrapper $column={hadAnyLG}>
      {/* Lifeguard block if anyone was protected at all */}
      {hadAnyLG && (
        <Header type="h3" align="center" padding="0">
          {hasLGNames
            ? lifeguardSavedNames.length === 1
              ? `The Lifeguard protected ${lifeguardSavedNames[0]} from the villains!`
              : `The Lifeguard protected ${joinWithAnd(
                  lifeguardSavedNames
                )} from the villains!`
            : "The Lifeguard protected someone from the villains!"}
        </Header>
      )}

      {hasSaved && (
        <PopupResults>
          <Header type="h3" align="center">
            {nightSaved.name} has survived the night.
          </Header>
          <CharacterCard
            image={nightSavedAsset?.imageUrl || ""}
            description={nightSavedDescNodes}
            role={nightSaved?.team || ""}
            status={"Alive"}
            title={nightSaved?.roleTitle || ""}
            listView={false}
            player={nightSaved?.name || ""}
          />
        </PopupResults>
      )}

      {/* Kill block if there were any night kills at all */}
      {hadAnyKills && (
        <PopupResults>
          <Header type="h3" align="center">
            {killedNames.length > 0
              ? `The villains killed ${joinWithAnd(killedNames)}:`
              : "The villains killed someone:"}
          </Header>
          <PopupRow>
            {nightKillVictims.map((v) => {
              const asset = v?.roleId ? roleAssets[v.roleId] : null;
              const desc = asset?.descriptionRich
                ? renderRichText(asset.descriptionRich)
                : null;
              return (
                <CharacterCard
                  key={v.id}
                  image={asset?.imageUrl || ""}
                  description={desc}
                  role={v?.team || ""}
                  status={"Dead"}
                  title={v?.roleTitle || ""}
                  listView={false}
                  player={v?.name || ""}
                />
              );
            })}
          </PopupRow>
        </PopupResults>
      )}
    </PopupWrapper>
  );
}
